export enum LabelMenu {
  Projects = 'nav_menu_projects',
  Products = 'nav_menu_products',
  Devices = 'nav_menu_devices',
  Transportations = 'nav_menu_transportations',
  Industries = 'nav_menu_industries',
  Combustible = 'nav_menu_combustible',
  Members = 'nav_menu_members',
  UserEntities = 'nav_menu_user_entities',
  Agencies = 'nav_menu_agencies',
  Users = 'nav_menu_users',
  Statistics = 'nav_menu_statistics',
  Administration = 'nav_menu_administration',
  Email = 'nav_menu_email',
  Transport = 'nav_menu_transport',
  Energie = 'nav_menu_energie',
  WorkInspection = 'nav_menu_work_inspection',
  CallForTender = 'nav_menu_call_for_tender',
  Help = 'nav_menu_help',
  PartnerApi = 'nav_menu_partner_api'
}
